import React, { useContext } from 'react'
import FileAccept from 'shared/components/file-portal/file-accept'
import FileInput from 'shared/components/inputs/file-input'
import styled from 'styled-components'
import { MIME_TYPES } from '../..'
import { GenericButton, PurpleButton } from '../../buttons'
import { UploadIcon } from '../../icons'
import { ZoomMakerWelcomeContext } from './../context'

const File = styled(FileInput)`
    position: relative;
    width: 100%;

    button {
        width: 100%;
    }

    input {
        cursor: pointer;
        height: 100%;
        left: 0;
        margin: 0;
        opacity: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }
`

const Button = FileAccept((props = {} as any) => (
    <File {...props} maxDuration={60} maxFilesize={100} mimeTypes={MIME_TYPES}>
        {props.children}
    </File>
))

type Props = {
    className?: string
    gradient?: boolean
}

const ZoomMakerUploadButton = ({ className, gradient }: Props) => {
    const { onError, onFileAccepted, onPreviewReady } = useContext(ZoomMakerWelcomeContext)
    return (
        <div className={className}>
            <Button
                {...{
                    onError,
                    onFileAccepted,
                    onPreviewReady,
                }}
            >
                {gradient ? (
                    <PurpleButton>
                        <UploadIcon /> Upload
                    </PurpleButton>
                ) : (
                    <GenericButton>Upload</GenericButton>
                )}
            </Button>
        </div>
    )
}

export default ZoomMakerUploadButton
